import { render, staticRenderFns } from "./Introduct.vue?vue&type=template&id=528c40bf&scoped=true&"
import script from "./Introduct.vue?vue&type=script&lang=js&"
export * from "./Introduct.vue?vue&type=script&lang=js&"
import style0 from "./Introduct.vue?vue&type=style&index=0&id=528c40bf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c40bf",
  null
  
)

export default component.exports